import { BiLogoGithub } from 'react-icons/bi';
import { IMenuItem } from '../../ui/UIMenu/IMenuItem';

// The site is organised by model: the three focus models, then everything else.
// The full lists of parts and repairs are in the footer.
export const menuItems: IMenuItem[] = [
  {
    title: 'BeoGram 400X',
    link: '/beogram/400x'
  }, {
    title: 'BeoGram 7000',
    link: '/beogram/7000'
  }, {
    title: 'BeoLink 7000',
    link: '/beolink/7000'
  }, {
    title: 'Other models',
    link: '/other-models'
  }, {
    title: 'Restoration',
    link: '/restoration-services',
    dataTestId: 'menu-link-services'
  }, {
    title: 'Contact',
    link: '/contact',
    dataTestId: 'menu-link-contact'
  }, {
    title: 'GitHub',
    icon: <BiLogoGithub />,
    link: 'https://github.com/leicht-io'
  }
];
